<template>
  <section
    class="list-item-container"
    :class="{ selected: selected, 'view-only': viewOnly }"
  >
    <div class="top-row">
      {{ template }}

      <select-box
        v-if="!viewOnly"
        class="select-holder"
        @action="$emit('select-box')"
        :selected="selected"
        :color="rootStore.interaction.subColor"
      ></select-box>
      <span v-if="viewOnly" class="quantity">{{ file.quantity }} x</span>
      <span class="file-name" :title="file.fileName">
        {{ file.fileName }}
      </span>
      <button
        v-if="!viewOnly"
        class="remove-file"
        @click.stop="removeFile(file)"
      >
        <svg class="trash" width="15px" height="15px" viewBox="0 0 15 15">
          <title>prullenmand</title>
          <g id="prullenmand">
            <path
              fill="#4f4f4f"
              d="M3,4 L3,13.25 C3,13.6642136 3.3581722,14 3.8,14 L10.2,14 C10.6418278,14 11,13.6642136 11,13.25 L11,4 L3,4 Z M9,2 L13,2 L13,3 L12,3 L12,13.4285714 C12,14.2964475 11.2538079,15 10.3333333,15 L3.66666667,15 C2.74619208,15 2,14.2964475 2,13.4285714 L2,3 L1,3 L1,2 L5,2 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 L9,2 Z M5,6 L5,12 L6,12 L6,6 L5,6 Z M8,6 L8,12 L9,12 L9,6 L8,6 Z"
            ></path>
          </g>
        </svg>
      </button>
    </div>
    <div class="specs-row" :class="{ small: viewOnly }">
      <quantity-input
        v-if="!viewOnly"
        v-model="quantity"
        @update:val="$emit('set-qt', $event)"
        @click.native="$emit('input-select')"
        @set-selectable="setSelectable"
      ></quantity-input>

      <custom-specs
        class="specs"
        v-if="!file.productSpecs.title && !productRequired"
        :compact="hideSpecs"
        :file="file"
        :selected="selected"
      ></custom-specs>
      <product-specs
        class="specs"
        v-else
        :specs="file.productSpecs"
        :productRequired="productRequired"
        :compact="hideSpecs"
      ></product-specs>
    </div>
  </section>
</template>

<script>
import QuantityInput from '@/components/ui/QuantityInput'
import ProductSpecs from './listitem/ProductSpecs.vue'
import CustomSpecs from './listitem/CustomSpecs.vue'
// import RetryImage from '@/components/ui/RetryImage'

export default {
  props: {
    color: String,
    selected: Boolean,
    file: Object,
    hideSpecs: Boolean,
    template: String,
    productRequired: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    quantity: {
      get() {
        return this.file.quantity
      },
      set(value) {
        this.$emit('set-qt', value)
      }
    }
  },
  components: {
    QuantityInput,
    ProductSpecs,
    CustomSpecs
  },
  methods: {
    removeFile(file) {
      this.$emit('remove', file)
    },
    previewUrl(previewName) {
      return `/media/print-order/preview/${previewName}/40`
    },
    setSelectable(val) {
      this.$emit('set-selectable', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@use '../../../sass/helpers/_variables.scss' as *;
@use '../../../sass/base/_colors.scss' as *;

$color: $main-color;
/* $red: red($color);
$green: green($color);
$blue: blue($color); */

.quantity {
  padding-right: 5px;
}

.list-item-container {
  padding: 15px;
  border-radius: 35px;
  transition: 0.5s all;

  &:hover {
    cursor: pointer;
    background-color: $list-hover;
  }

  &.view-only:hover {
    background-color: white;
    cursor: unset;
  }
}

.selected {
  background-color: var(--selected-color);
  &:hover {
    background-color: var(--selected-color);
  }
}

.top-row {
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;

  .select-holder {
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0;
  }
}

.specs-row {
  display: flex;
  //  align-items: top;
  padding-top: 5px;
  padding-left: 5px;

  &.small {
    padding-top: 5px;
  }
}

.specs {
  padding-top: 9px;
  flex-grow: 1;
  //  margin-bottom: -7px;
}

.input-holder {
  margin-right: 10px;
}

.file-name {
  padding-left: 1px;
  line-height: 17px;
  font-weight: 600;
  flex-grow: 1;
  word-break: break-word;
}

.trash {
  width: 21px;
  height: 21px;
  padding: 3px;

  &:hover {
    path {
      transition: fill 0.4s;
      fill: $rijnja-red;
    }
  }
}

.remove-file {
  margin-top: auto;
  margin-right: -2px;
}

.preview-container,
.preview {
  width: 40px;
  height: 40px;
}

.preview-container {
  margin-right: 16px;
}
</style>
